<template>
  <div v-if="events && events.length">
    <table-blue :cols="cols">
    </table-blue>
    <table-blue-label-count :amount="events.length" />
  </div>
  <table-blue-no-result v-else />
</template>

<script>
import TableBlue from './TableBlue/TableBlue';
import TableBlueLabelDate from './TableBlue/TableBlueLabelDate';
import TableBlueLabelGame from './TableBlue/TableBlueLabelGame';
import TableBlueLabelValue from './TableBlue/TableBlueLabelValue';
import TableBlueLabelBalance from './TableBlue/TableBlueLabelBalance';
import TableBlueLabelCount from './TableBlue/TableBlueLabelCount';
import TableBlueNoResult from './TableBlue/TableBlueNoResult';

export default {
  name: 'TableBluePlayerEvents',
  props: ['events'],
  components: {
    TableBlue,
    TableBlueLabelDate,
    TableBlueLabelGame,
    TableBlueLabelValue,
    TableBlueLabelBalance,
    TableBlueLabelCount,
    TableBlueNoResult
  },
  data() {
    return {
      cols: [
        { i18n: 'th.date', align: 'center' },
        { i18n: 'th.game', align: 'center' },
        { i18n: 'th.event', align: 'center' },
        { i18n: 'th.value', align: 'right' },
        { i18n: 'th.balance', align: 'right' },
      ]
    }
  }
}
</script>



